import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import TranslationService from "../../../Services/translationService";
import ApiService from "../../../Services/apiService";
import NoDataImage from "../../../assets/images/illustrations/nodata.svg";
import { Link, withRouter } from "react-router-dom";
import {
	addPartialViewSpinner,
	removePartialViewSpinner,
	addModalSpinner,
	removeModalSpinner,
} from "../../../Store/Actions/spinner";
import uuid from "react-uuid";
import AlertService from "../../../Services/alertService";
import {
	ERROR_KEY,
	SUCCESS_KEY,
	TR_NO,
	TR_YES,
} from "../../../Constants/mainKeys";
import ReactPaginate from "react-paginate";
import _InfoSvg from "../../../Components/Svg/_infoSvg";
import PageInfoBlock from "../../../Components/PageInfoBlock/PageInfoBlock";
import ModalComponent from "../../../Components/ModalComponent/modalComponent";
import InputCheckBox from "../../../Components/Inputs/inputCheckBox";
import { Collapse } from "react-bootstrap";
import SettingsSvg from "../../../Components/Svg/settingsSvg";
import MainService from "../../../Services/mainService";
import RolesService from "../../../Services/rolesService";

const EducationalUnits = props => {
	const pageSize = 10;
	const dispatch = useDispatch();
	const { translations } = useSelector(state => state.translation);
	const { language } = useSelector(state => state.language);
	const [translationService, setTranslationService] = useState(null);
	const [educationalUnits, setEducationalUnits] = useState([]);
	const [pagination, setPagination] = useState(null);
	const [activePageNumber, setActivePageNumber] = useState(0);
	const [ids, setIds] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [selectItems, setSelectItems] = useState([]);
	const [values, setValues] = useState([]);
	const [isActivStudents, setIsActivStudents] = useState(false);
	const [isChange, setIsChange] = useState(false);
	const { role, user } = useSelector(state => state.user);
	const [roleService, setRoleService] = useState(null);
	const [moadlTitle, setModalTitle] = useState("divisions");

	useEffect(() => {
		MainService.isJson(role) &&
			setRoleService(new RolesService(JSON.parse(role)));
	}, [role]);

	useEffect(() => {
		setTranslationService(new TranslationService(translations));
	}, [translations]);

	useEffect(() => {
		getDivisions(1);
	}, []);

	const onChangeIds = id => {
		if (ids.includes(id)) {
			const newIds = ids.filter(el => el !== id);
			setIds(newIds);
		} else {
			setIds([...ids, id]);
		}
	};

	const handlePageClick = event => {
		getDivisions(event.selected + 1);
		setActivePageNumber(event.selected);
	};

	const getDivisions = currentPage => {
		const spinnerId = uuid();
		dispatch(addPartialViewSpinner(spinnerId));
		ApiService.getEducationalUnits(currentPage, pageSize)
			.then(response => {
				if (response && response.pagination)
					setPagination(JSON.parse(response.pagination));
				if (response && response.data) {
					setEducationalUnits(response.data);
				}
				dispatch(removePartialViewSpinner(spinnerId));
			})
			.catch(error => getFail(error, spinnerId));
	};

	const deleteEducationalUnit = item => {
		const spinnerId = uuid();
		AlertService.alertConfirm(
			`${translationService.translate("TR_ARE_YOU_SURE_MODAL")}`,
			`You want to delete ${item.name} educational unit`,
			translationService.translate(TR_YES),
			translationService.translate(TR_NO),
		).then(() => {
			dispatch(addPartialViewSpinner(spinnerId));
			ApiService.deleteEducationalUnit(item.id)
				.then(() => {
					setEducationalUnits(
						educationalUnits.filter(_item => _item.id !== item.id),
					);
					dispatch(removePartialViewSpinner(spinnerId));
					AlertService.alert(
						SUCCESS_KEY,
						translationService.translate("TR_DATA_SAVED"),
					);
				})
				.catch(error => getFail(error, spinnerId));
		});
	};

	const onClose = () => {
		setIsChange(false);
		setValues([]);
		setSelectItems([]);
		setIsActivStudents(false);
		setOpenModal(false);
		setModalTitle("divisions");
	};

	const onSave = () => {
		const spinerID = uuid();
		setIsChange(false);
		dispatch(addModalSpinner(spinerID));
		(moadlTitle === "divisions"
			? ApiService.setEducationalDivisions({
					educationalUnitId: openModal.id,
					divisionIds: values,
			  })
			: ApiService.setEducationalLecturers({
					educationalUnitId: openModal.id,
					lecturerUserIds: values,
			  })
		)
			.then(res => {
				AlertService.alert(
					SUCCESS_KEY,
					translationService.translate("TR_DATA_SAVED"),
				);
				onClose();
			})
			.catch(error => {
				AlertService.alert(
					AlertService.checkMessageType(error.respcode) || ERROR_KEY,
					error,
				);
			})
			.finally(() => {
				dispatch(removeModalSpinner(spinerID));
			});
	};

	const getFail = (error, spinnerId) => {
		error &&
			AlertService.alert(
				AlertService.checkMessageType(error.respcode) || ERROR_KEY,
				error,
			);
		spinnerId && dispatch(removePartialViewSpinner(spinnerId));
	};

	const getModalData = (
		item,
		moadlTitle = "divisions",
		openModal = true,
		isActiv = true,
	) => {
		if (!item) return;
		if (openModal) setOpenModal(item);
		const spinerId = uuid();
		dispatch(addModalSpinner(spinerId));
		(moadlTitle === "divisions"
			? ApiService.getEducationalDivisions(item.id, isActiv)
			: ApiService.getEducationalLecturers(item.id, isActiv)
		)
			.then(response => {
				if (response.data && response.data.length) {
					setSelectItems(response.data);
					let attachedStudents = response.data
						.filter(
							el =>
								el?.isBelongToCurrentEducationalUnit ||
								el?.isBelongToCurrentEducationalUnit,
						)
						.map(el => el.id);
					setValues(attachedStudents);
				} else {
					setSelectItems([]);
					setValues([]);
				}
			})
			.catch(error => {
				AlertService.alert(
					AlertService.checkMessageType(error.respcode) || ERROR_KEY,
					error,
				);
				onClose();
			})
			.finally(() => {
				dispatch(removeModalSpinner(spinerId));
			});
	};

	return translationService ? (
		<div className="container">
			{openModal && (
				<ModalComponent
					cancel={onClose}
					onSubmit={onSave}
					addButtonIsDisabled={!isChange}
					isLarge={true}
					title={`Attach/Detach ${moadlTitle}`}
					actionButtonTitle={
						selectItems?.length ? translationService.translate("TR_SAVE") : ""
					}>
					{selectItems?.length ? (
						<div className="row">
							<div className="col-12">
								<div className="custom-control custom-switch">
									<div className="d-flex align-items-center">
										<input
											type="checkbox"
											id="save"
											className="custom-control-input"
											checked={isActivStudents}
											onChange={event => {
												setIsActivStudents(event.target.checked);
												getModalData(
													openModal,
													moadlTitle === "divisions" ? "divisions" : "",
													false,
													!event.target.checked,
												);
											}}
										/>
										<label htmlFor="save" className="custom-control-label">
											Show only educational unit divisions
										</label>
									</div>
								</div>
								<hr />
							</div>
							{!isActivStudents && selectItems?.length && (
								<div className="col-12">
									<InputCheckBox
										id={"select_all"}
										name={"select_all"}
										checked={values.length === selectItems.length}
										labelValue={"Select all"}
										onChange={event => {
											setIsChange(true);
											if (event.target.checked) {
												const selectedValue = selectItems.map(el => el.id);
												setValues(selectedValue);
											} else {
												setValues([]);
											}
										}}
									/>
								</div>
							)}
							{selectItems &&
								!!selectItems.length &&
								selectItems.map((item, i) => (
									<div className="col-12 col-md-6" key={i}>
										<InputCheckBox
											id={`students_${item.id}`}
											name={`students_${item.id}`}
											checked={values.filter(el => el === item.id).length}
											labelValue={item?.divisionName || item?.lecturerName}
											onChange={event => {
												setIsChange(true);
												if (event.target.checked) {
													setValues([...values, item.id]);
												} else {
													const selectedValue = values.filter(
														el => el !== item.id,
													);
													setValues(selectedValue);
												}
											}}
										/>
									</div>
								))}
						</div>
					) : (
						<div className="no-data-container mt-3">
							<div className="no-data-wrapper">
								<img src={NoDataImage} alt="/" height={150} />
							</div>
						</div>
					)}
				</ModalComponent>
			)}
			<div className="row mt-4">
				<div className="col-12">
					<h2 className="section-title">Educational units</h2>
					<PageInfoBlock
						pageTitle="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
						infoText="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
						translationService={translationService}
					/>
				</div>
			</div>
			<hr />
			{/* {roleService.checkRole("group_create") && ( */}
			<div className="row">
				<div className="col-12">
					<div className="mb-2">
						<Link
							to={`/${language}/educational-unit-form`}
							className="mindalay--btn-default">
							Create a educational unit
						</Link>
					</div>
				</div>
			</div>
			{/* )} */}
			{educationalUnits && educationalUnits.length ? (
				<div className="row">
					<div className="col-12">
						<EducetionAcardion
							open={onChangeIds}
							ids={ids}
							data={educationalUnits}
							translationService={translationService}
							roleService={roleService}
							deleteEducationalUnit={deleteEducationalUnit}
							openModal={getModalData}
							setModalTitle={setModalTitle}
						/>
					</div>
				</div>
			) : (
				<div className="no-data-container mt-3">
					<div className="no-data-wrapper">
						<img src={NoDataImage} alt="/" />
					</div>
				</div>
			)}
			{pagination ? (
				<div className="row mt-5">
					<div className="col-12 mt-4">
						<div className="d-flex justify-content-end">
							<ReactPaginate
								nextLabel={translationService.translate("TR_NEXT")}
								onPageChange={handlePageClick}
								pageRangeDisplayed={3}
								marginPagesDisplayed={2}
								pageCount={pagination.TotalPages}
								previousLabel={translationService.translate("TR_PREVIOUS")}
								pageClassName="page-item"
								pageLinkClassName="page-link"
								previousClassName="page-item"
								previousLinkClassName="page-link"
								nextClassName="page-item"
								nextLinkClassName="page-link"
								breakLabel="..."
								breakClassName="page-item"
								breakLinkClassName="page-link"
								containerClassName="pagination"
								activeClassName="active"
								renderOnZeroPageCount={null}
								forcePage={activePageNumber}
							/>
						</div>
					</div>
				</div>
			) : null}
		</div>
	) : null;
};

export default withRouter(EducationalUnits);

const EducetionAcardion = ({
	data,
	translationService,
	ids = [],
	open,
	background = "white-background",
	roleService,
	openModal,
	deleteEducationalUnit,
	setModalTitle,
}) => {
	const language = useSelector(state => state.language.language);
	if (Array.isArray(data) && !data?.length) return null;

	return (
		data &&
		!!data.length && (
			<div
				className="accordion-wrapper m-0"
				style={{ position: "relative", zIndex: 0 }}>
				<div className="row" style={{ position: "relative", zIndex: 0 }}>
					{data.map((item, i) => {
						return (
							<div
								key={i}
								className={`col-12 ${item?.children ? "" : "mt-2"}`}
								style={{ position: "relative", zIndex: `${0 - i}` }}>
								<div className="card mindalay-card">
									<div
										className="card-header"
										style={{ zIndex: "0 !important" }}
										aria-controls={`section_${item.id}`}
										aria-expanded={ids.includes(item.id)}
										onClick={() => open(item.id)}>
										<h5 className="text-elipsis">{item.name}</h5>

										<div className="dropleft setting-dropdown">
											<div
												className="setting-dropdown-btn"
												id={`demo-${item.id}`}
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false">
												<SettingsSvg />
											</div>
											<div
												id={`demo-${item.id}`}
												className="dropdown-menu collapse">
												{item.lecturerAttachmentOn && (
													<Link
														to="#"
														className="dropdown-item"
														onClick={() => {
															setModalTitle("lecturers");
															openModal(item, "");
														}}>
														Attach lecturer
													</Link>
												)}
												{item.divisionAttachmentOn && (
													<Link
														to="#"
														className="dropdown-item"
														onClick={() => {
															openModal(item);
														}}>
														Attach division
													</Link>
												)}
												{/* {!!roleService.checkRole("group_update") && ( */}
												<Link
													to={`/${language}/educational-unit-form/${item.id}`}
													className="dropdown-item"
													onClick={() => {}}>
													{translationService.translate("TR_EDIT")}
												</Link>
												{/* )} */}
												{/* {!!roleService.checkRole("group_delete") && ( */}
												<Link
													to="#"
													className="dropdown-item"
													onClick={() => {
														deleteEducationalUnit(item);
													}}>
													{translationService.translate("TR_DELETE")}
												</Link>
												{/* )} */}
											</div>
										</div>
									</div>

									<Collapse in={ids.includes(item.id)}>
										<div
											id={`topic_${item.id}`}
											className={`${
												background === "white-background"
													? "white-background"
													: "light-blue-background"
											} content-block m-0`}
											style={{ padding: "0 0 0 0.75rem" }}>
											{!!item.description && (
												<div className="my-3 text-muted">
													{item.description}
												</div>
											)}
											{item.children && !!item.children.length && (
												<EducetionAcardion
													open={open}
													ids={ids}
													data={item.children}
													translationService={translationService}
													background={
														background === "white-background"
															? "light-blue-background"
															: "white-background"
													}
													roleService={roleService}
													openModal={openModal}
													deleteEducationalUnit={deleteEducationalUnit}
													setModalTitle={setModalTitle}
												/>
											)}
										</div>
									</Collapse>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		)
	);
};
